import ReactSelectWebComponentProvider from './ReactSelectWebComponentProvider';

export default ReactSelectWebComponentProvider;